import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getFirestore, collection, getDoc, doc } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

// Inicializa la aplicación de Firebase
const cfg = process.env.REACT_APP_FIREBASE;
const app = initializeApp(typeof cfg == 'string' ? JSON.parse(cfg) : cfg);
// const auth = getAuth(app);

const doLogin = async (user, password) => {
    let ret = null;
    try {
        ret = signInWithEmailAndPassword(getAuth(app), user, password);
        return ret;
    } catch (error) {
        console.log(error.message);
    }
    return ret;
}

const logOut = () => signOut;

const getPolicy = async (lang) => {
    const db = getFirestore(app);
    const pagesRef = collection(db, 'pages')
    let data = await getDoc(doc(pagesRef, `default-privacy-${lang}`));
        if(!data.exists()) {
            data = await getDoc(doc(pagesRef, `default-privacy-es`));
        }
    return(data.data());
}

const getCondition = async (lang) => {
    const db = getFirestore(app);
    const pagesRef = collection(db, 'pages')
    let data = await getDoc(doc(pagesRef, `default-condition-${lang}`));
    if (!data.exists()) {
        data = await getDoc(doc(pagesRef, `default-condition-es`));
    }
    return (data.data());
}

const getChildSafety = async (lang) => {
    const db = getFirestore(app);
    const pagesRef = collection(db, 'pages')
    let data = await getDoc(doc(pagesRef, `default-child-safety-${lang}`));
    if (!data.exists()) {
        data = await getDoc(doc(pagesRef, `default-child-safety-es`));
    }
    return (data.data());
}

const getSiteName = async () => {
    const db = getFirestore(app);
    const collRef = collection(db, 'pages');
    let data = await getDoc(doc(collRef, `config`));
    const ret = data?.data()?.name || '';
    return(ret);
}

const getQrs = async () => {
    const db = getFirestore(app);
    const collRef = collection(db, 'pages');
    let data = await getDoc(doc(collRef, `qrs`));
    const ret = data?.data()?.apps || [];
console.log(ret);    
    return(ret);
}

const getLogo = async (imgage='logo.png') => {
    try {
        const storage = getStorage(app);
        const storageRef = ref(storage, `kaps-apps/${imgage}`);
        const img = await getDownloadURL(storageRef);
        return img;
    } catch (error) {
        return '';
    }
}

const getStyles = async () => {
    try {
        const db = getFirestore(app);
        const collRef = collection(db, 'pages');
        let data = await getDoc(doc(collRef, `styles`));
        const ret = data?.data() || {};
        return (ret);
    } catch (error) {
        return '';
    }
}

// si tuvieramos estilos para cada plantilla sería este metodo en lugar de getStyles
// const getPageStyles = async (subcoll = "default", pageId = "default") => {
//     try {
//         const db = getFirestore(app);
//         const ref = doc(db, `pages/config/${subcoll}`, pageId); //pages/config/condition-styles/default. 
//         // la subcoll será el componente del que queremos recuperar su css: privacidad, coondiciones,...
//         // y con distintos pageIds dentro de la misma subcoll podriamos tener varias versiones de css, lo dejamos preparado 
//         // aunque es posible que no lo usemos jamás y siempre sea el page default 
//         const snap = await getDoc(ref);
//         if (snap.exists()) {
//             return snap.data(); // aquí devolvemos el objeto css { container: {...}, inner: {...}, ... }
//         }
//         return {};
//     } catch (error) {
//         return '';
//     }
// }

export {
    doLogin,
    logOut,
    getPolicy,
    getCondition,
    getSiteName,
    getQrs,
    getLogo,
    getStyles,
    //getPageStyles
    getChildSafety,
}